<script>
import axios from 'axios';

export default class PlanoMatrizRepository {

    async uploadReenquadramentos(url, formData, token) {
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        
        try {
            const response = await axios.post(url, formData, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar Matriz de Reenquadramentos:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getReenquadramentos(url, token) {
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        
        try {
            const response = await axios.get(url, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao buscar Matriz de Reenquadramentos:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    createReenquadramento(url, data, token) {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        return axios.post(url, data, { headers });
    }

    deleteReenquadramento(url, token) {
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        return axios.delete(url, { headers });
    }

}
</script>
